module.exports = __webpack_public_path__ + "img/bg2.6c3b7b11.png";